import { convertData } from '@shared/innmaxLib/services'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetCompanies } from '@services/companies'
import { DeviceActive, DeviceActiveStr } from '@services/constants'
import { pathOr } from 'ramda'
import type { ISessionInfo, IUser } from './user.types'

export const useConvertIUsers = (res: any) => {
  const { activeStr, sessionName } = useConvertData()

  const { byId: byIdCompanies } = useGetCompanies()

  const dataSource = React.useMemo(
    () =>
      convertData<IUser>({
        converter: x => {
          return {
            ...x,
            status: Number(x.status),
            email: x?.properties?.email,
            mobile: x?.properties?.phone,
            loginTime: x?.loginTime && moment(Number(x?.loginTime)),
            loginTimeStr:
              x?.loginTime &&
              moment(Number(x?.loginTime)).format('YYYY.MM.DD HH:mm:ss'),
            orgSessionName: pathOr(
              '--',
              [x?.orgSessionId || -1, 'name'],
              byIdCompanies
            ),
            ...activeStr(x),
            ...sessionName(x),
          }
        },
      })(res),
    [res, byIdCompanies] //eslint-disable-line
  )

  return dataSource
}

export const useConvertData = () => {
  const { t } = useTranslation()

  const activeStr = (x: any) => {
    const status =
      x.status === -1
        ? DeviceActive.DELETE
        : x.status === 0
        ? DeviceActive.INACTIVE
        : DeviceActive.ACTIVE

    return {
      statusStr: t(`common:${DeviceActiveStr[status]}`),
    }
  }

  const sessionName = (x: any) => {
    const sessionStr = x.allSessionPermission
      ? t('common:all area')
      : x?.sessionInfos?.map((i: ISessionInfo) => i.name).join(' / ')

    const sessionIds = x.allSessionPermission
      ? [-1]
      : x?.sessionInfos?.map((i: ISessionInfo) => i.id)

    return {
      sessionStr,
      sessionIds,
    }
  }

  return {
    activeStr,
    sessionName,
  }
}
